export interface IRedactorProperty {
  prop: string;
  leftPad: number;
  rightPad: number;
}

// Note: 'leftPad' and 'rightPad' determine how much of the original
// property value is okay to reveal without giving the entire value
// away. For example, an 'api_key' prop set to 'f3sf4gss' would only reveal
// the last 4 characters as defined here: '****4gss'
export const defaultProperties: Array<IRedactorProperty> = [
  { prop: 'api_key', leftPad: 0, rightPad: 4 },
  { prop: 'api-key', leftPad: 4, rightPad: 4 },
  { prop: 'api-token', leftPad: 4, rightPad: 4 },
  { prop: 'api_token', leftPad: 4, rightPad: 4 },
  { prop: 'token', leftPad: 4, rightPad: 4 },
  { prop: 'authorization', leftPad: 4, rightPad: 4 },
  { prop: 'bearer', leftPad: 4, rightPad: 4 },
  { prop: 'secret', leftPad: 0, rightPad: 0 },
  { prop: 'first_name', leftPad: 0, rightPad: 2 },
  { prop: 'firstName', leftPad: 0, rightPad: 2 },
  { prop: 'last_name', leftPad: 0, rightPad: 2 },
  { prop: 'lastName', leftPad: 0, rightPad: 2 },
  { prop: 'middle_name', leftPad: 0, rightPad: 2 },
  { prop: 'middleName', leftPad: 0, rightPad: 2 },
  { prop: 'gender', leftPad: 0, rightPad: 0 },
  { prop: 'email', leftPad: 0, rightPad: 5 },
  { prop: 'email_address', leftPad: 0, rightPad: 5 },
  { prop: 'patient_pre_auth_id_talkiatry_app', leftPad: 0, rightPad: 5 },
  { prop: 'password', leftPad: 0, rightPad: 0 },
  { prop: 'ssn', leftPad: 0, rightPad: 4 },
  { prop: 'license_number', leftPad: 0, rightPad: 4 },
  { prop: 'driver_license_number', leftPad: 0, rightPad: 4 },
  { prop: 'phone', leftPad: 0, rightPad: 0 },
  { prop: 'phone-number', leftPad: 0, rightPad: 0 },
  { prop: 'state', leftPad: 0, rightPad: 0 },
  { prop: 'address_line_1', leftPad: 0, rightPad: 5 },
  { prop: 'address_line_2', leftPad: 0, rightPad: 0 },
  { prop: 'phoneNumber', leftPad: 0, rightPad: 0 },
  { prop: 'addressStreet1', leftPad: 0, rightPad: 5 },
  { prop: 'addressStreet2', leftPad: 0, rightPad: 0 },
  { prop: 'address_1', leftPad: 0, rightPad: 5 },
  { prop: 'address_2', leftPad: 0, rightPad: 0 },
  { prop: 'city', leftPad: 0, rightPad: 0 },
  { prop: 'addressCity', leftPad: 0, rightPad: 0 },
  { prop: 'addressState', leftPad: 0, rightPad: 0 },
  { prop: 'zip', leftPad: 0, rightPad: 2 },
  { prop: 'addressZipCode', leftPad: 0, rightPad: 2 },
  { prop: 'zip_code', leftPad: 0, rightPad: 0 },
  { prop: 'line1', leftPad: 0, rightPad: 0 },
  { prop: 'full_name', leftPad: 0, rightPad: 0 },
  { prop: 'dob', leftPad: 0, rightPad: 0 },
  { prop: 'date_of_birth', leftPad: 0, rightPad: 0 },
  { prop: 'birthDate', leftPad: 0, rightPad: 0 },
  { prop: 'base64', leftPad: 10, rightPad: 10 },
  { prop: 'contents', leftPad: 10, rightPad: 10 },
  { prop: 'pdf', leftPad: 10, rightPad: 10 },
  { prop: 'data', leftPad: 10, rightPad: 10 },
  { prop: 'url', leftPad: 0, rightPad: 5 },
  { prop: 'directUrl', leftPad: 0, rightPad: 5 },
  { prop: 'fileName', leftPad: 2, rightPad: 2 },
  { prop: 'npi', leftPad: 1, rightPad: 1 },
];
